export default "__VITE_ASSET__CC7bRvo9__"